import { render, staticRenderFns } from "./dimension-select.vue?vue&type=template&id=3a4b6f03&scoped=true"
import script from "./dimension-select.vue?vue&type=script&lang=ts"
export * from "./dimension-select.vue?vue&type=script&lang=ts"
import style0 from "./dimension-select.vue?vue&type=style&index=0&id=3a4b6f03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4b6f03",
  null
  
)

export default component.exports